export function createTaroMouseEvent(taroEventType, reactEvent) {
    const { timeStamp, target, currentTarget } = reactEvent;
    const changedTouches = 'changedTouches' in reactEvent
        ? reactEvent.changedTouches
        : [reactEvent];
    const touches = 'touches' in reactEvent
        ? reactEvent.touches
        : [reactEvent];
    return {
        currentTarget,
        target,
        detail: {
            x: changedTouches[0].screenX,
            y: changedTouches[0].screenY
        },
        timeStamp,
        type: taroEventType,
        changedTouches,
        touches,
        preventDefault: () => reactEvent.preventDefault(),
        stopPropagation: () => reactEvent.stopPropagation()
    };
}
export function createTaroTouchEvent(taroEventType, reactEvent) {
    const { timeStamp, target, currentTarget } = reactEvent;
    const changedTouches = 'changedTouches' in reactEvent
        ? reactEvent.changedTouches
        : [reactEvent];
    const touches = 'touches' in reactEvent
        ? reactEvent.touches
        : [reactEvent];
    return {
        currentTarget,
        target,
        detail: {},
        timeStamp,
        type: taroEventType,
        changedTouches,
        touches,
        preventDefault: () => reactEvent.preventDefault(),
        stopPropagation: () => reactEvent.stopPropagation()
    };
}
export function createTaroEvent(taroEventType, eventTarget, detail) {
    return {
        currentTarget: eventTarget,
        target: eventTarget,
        detail,
        timeStamp: Date.now(),
        type: taroEventType,
        preventDefault() { },
        stopPropagation() { }
    };
}
export function createTaroFocusEvent(reactEvent) {
    const { timeStamp, target, currentTarget } = reactEvent;
    const el = target;
    return {
        currentTarget,
        target,
        detail: {
            height: 0,
            value: el.value
        },
        timeStamp,
        type: 'focus',
        preventDefault: () => reactEvent.preventDefault(),
        stopPropagation: () => reactEvent.stopPropagation()
    };
}
export function createTaroBlurEvent(reactEvent) {
    const { timeStamp, target, currentTarget } = reactEvent;
    const el = target;
    return {
        currentTarget,
        target,
        detail: {
            cursor: el.selectionEnd || 0,
            value: el.value
        },
        timeStamp,
        type: 'blur',
        preventDefault: () => reactEvent.preventDefault(),
        stopPropagation: () => reactEvent.stopPropagation()
    };
}
export function createTaroConfirmEvent(reactEvent) {
    const { timeStamp, target, currentTarget } = reactEvent;
    const el = target;
    return {
        currentTarget,
        target,
        detail: {
            value: el.value
        },
        timeStamp,
        type: 'confirm',
        preventDefault: () => reactEvent.preventDefault(),
        stopPropagation: () => reactEvent.stopPropagation()
    };
}
export function createTaroVideoEvent(taroEventType, reactEvent) {
    const { timeStamp, target, currentTarget } = reactEvent;
    return {
        currentTarget,
        target,
        detail: {
            videoId: currentTarget.id
        },
        timeStamp,
        type: taroEventType,
        preventDefault: () => reactEvent.preventDefault(),
        stopPropagation: () => reactEvent.stopPropagation()
    };
}
export function createTaroSwitchEvent(reactEvent) {
    const { timeStamp, target, currentTarget } = reactEvent;
    return {
        currentTarget,
        target,
        detail: {
            checked: currentTarget.checked
        },
        timeStamp,
        type: 'change',
        preventDefault: () => reactEvent.preventDefault(),
        stopPropagation: () => reactEvent.stopPropagation()
    };
}
export function createTaroSwiperEvent(taroEventType, swiper) {
    const { el, realIndex } = swiper;
    return {
        currentTarget: el,
        target: el,
        detail: {
            current: realIndex
        },
        timeStamp: Date.now(),
        type: taroEventType,
        preventDefault() { },
        stopPropagation() { }
    };
}
export function createTaroPickerViewEvent(el, value) {
    return {
        currentTarget: el,
        target: el,
        detail: {
            value
        },
        timeStamp: Date.now(),
        type: 'change',
        preventDefault() { },
        stopPropagation() { }
    };
}
export function createTaroFormSubmitEvent(el, value) {
    return {
        currentTarget: el,
        target: el,
        detail: {
            value
        },
        timeStamp: Date.now(),
        type: 'submit',
        preventDefault() { },
        stopPropagation() { }
    };
}
